<template>
  <audio class="AudioPlay" id="audio"></audio>
</template>

<script>
import flvjs from "flv.js";

export default {
  name: "AudioPlay",
  props: ["audioPlayer"],
  data() {
    return {
      flvPlayer: null,
      reconnectTimeout: null,
      loaded: false,
      audioElement: null,
      ws: null,
      _playAudio: null,
    };
  },
  methods: {
    load() {
      // this.initAACPlayer();
    },

    initAACPlayer() {
      const audioSrc = this.audioPlayer.audioSrc;
      console.log("audioFlvSrc:", audioSrc);

      if (flvjs.isSupported()) {
        this.audioElement = document.querySelector("#audio");
        console.log(this.audioElement);
        if (!this.flvPlayer) {
          this.flvPlayer = flvjs.createPlayer(
            {
              type: "flv",
              isLive: true,
              url: audioSrc,
              hasAudio: true,
              hasVideo: false,
              cors: true,
            },
            {
              enableStashBuffer: false,
              deferLoadAfterSourceOpen: false,
              autoCleanupSourceBuffer: true,
              autoCleanupMaxBackwardDuration: 30,
              autoCleanupMinBackwardDuration: 10,
              statisticsInfoReportInterval: 2000,
            }
          );
        }

        this.flvPlayer.on(flvjs.Events.ERROR, this._onError.bind(this));
        this.flvPlayer.on(flvjs.Events.IO_OPENED, this._onOpen.bind(this));
        this.flvPlayer.on(
          flvjs.Events.LOADING_COMPLETE,
          this._onPlayComplete.bind(this)
        );
        this.flvPlayer.on(
          flvjs.Events.METADATA_ARRIVED,
          this._onMetaDataArrived.bind(this)
        );
        this.flvPlayer.attachMediaElement(this.audioElement);
        this.flvPlayer.load();
        this.loaded = true;
        console.log("audioFlvSrc11:", audioSrc);
      } else {
        this.audioPlayer.setPromptWord("notSupport");
      }
    },
    unload() {
      if (this.flvPlayer) {
        try {
          this.flvPlayer.pause();
        } catch (e) {
          console.warn("AudioPlay: pause error", e);
        }
        try {
          this.flvPlayer.unload();
        } catch (e) {
          console.warn("AudioPlay: unload error", e);
        }
        this.loaded = false;
        this.playing = false;
      }
    },
    getMediaInfo() {
      return this.flvPlayer ? this.flvPlayer.mediaInfo : null;
    },
    destroy() {
      if (this.flvPlayer) {
        try {
          this.unload();
        } catch (e) {
          console.warn("AudioPlay: unload in destroy error", e);
        }
        this.audioElement = null;
        try {
          this.flvPlayer.detachMediaElement();
        } catch (e) {
          console.warn("AudioPlay: detachMediaElement error", e);
        }
        try {
          this.flvPlayer.destroy();
        } catch (e) {
          console.warn("AudioPlay: flvPlayer destroy error", e);
        }
        this.flvPlayer = null;
      } else {
        if (this.ws) {
          try {
            this.ws.close();
          } catch (e) {
            console.warn("AudioPlay: ws close error", e);
          }
          this.ws = null;
        }
        if (this._playAudio) {
          try {
            this._playAudio.destroy();
          } catch (e) {
            console.warn("AudioPlay: _playAudio destroy error", e);
          }
          this._playAudio = null;
        }
      }
    },
    getCurrentTime() {
      return this.flvPlayer && this.loaded ? this.flvPlayer.currentTime : 0;
    },
    setCurrentTime(time) {
      if (this.flvPlayer && this.loaded) {
        this.flvPlayer.currentTime = time;
      }
    },
    getBuffered() {
      return this.flvPlayer && this.loaded ? this.flvPlayer.buffered : null;
    },
    getPlaybackRate() {
      return this.audioElement ? this.audioElement.playbackRate : 1;
    },
    setVolume(volume) {
      if (this.audioElement) {
        this.audioElement.volume = Math.max(0, Math.min(1, volume));
      }
    },
    setPlaybackRate(rate) {
      if (this.audioElement) {
        this.audioElement.playbackRate = rate;
      }
    },
    getPaused() {
      return this.audioElement ? this.audioElement.paused : false;
    },
    pause() {
      if (this.audioElement) {
        this.audioElement.pause();
      }
    },
    play() {
      if (this.audioElement) {
        this.audioElement.play();
      }
    },
    setDebugMode(enable) {
      console.log("audio player setDebugMode: ", enable);
      if (enable) {
        flvjs.LoggingControl.enableAll = true;
      } else {
        flvjs.LoggingControl.enableDebug = false;
        flvjs.LoggingControl.enableVerbose = false;
        flvjs.LoggingControl.enableInfo = false;
      }
    },
    send(data) {
      if (this.flvPlayer) {
        this.flvPlayer.send(data);
      } else if (this.ws) {
        this.ws.send(data);
      }
    },
    _onMetaDataArrived() {
      if (this.audioPlayer.videoPlayer) {
        switch (this.audioPlayer.videoPlayer.playerType) {
          case "ls":
            this.audioPlayer.setPromptWord("listening");
            break;
          case "tk":
            this.audioPlayer.setPromptWord("talkback");
            break;
          case "bc":
            this.audioPlayer.setPromptWord("broadcast");
            break;
        }
      }
    },
    _onOpen() {
      this.audioPlayer.setPromptWord("connSuccess");
      if (
        this.audioPlayer.videoPlayer &&
        this.audioPlayer.videoPlayer.playerType === "bc"
      ) {
        this.audioPlayer.setPromptWord("broadcast");
      }
    },
    _onError(errorType, errorDetail) {
      console.log("audioplay event: error， type:", errorType, errorDetail);
      // 音频编解码格式不支持时，停止重连并提示用户
      if (
        errorType === flvjs.ErrorTypes.MEDIA_ERROR &&
        errorDetail === flvjs.ErrorDetails.MEDIA_FORMAT_UNSUPPORTED
      ) {
        this.audioPlayer.audioStatus = 0;
        this.audioPlayer.setPromptWord("notSupport");
        this.destroy();
        return;
      }
      if (
        errorType === flvjs.ErrorTypes.NETWORK_ERROR ||
        (errorType === flvjs.ErrorTypes.MEDIA_ERROR &&
          errorDetail === flvjs.ErrorDetails.MEDIA_MSE_ERROR)
      ) {
        if (this.audioPlayer.audioStatus === 1) {
          this.unload();
          if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
          }
          this.reconnectTimeout = setTimeout(this._reconnect.bind(this), 3000);
        } else {
          setTimeout(this.destroy.bind(this), 0);
        }
      }
    },
    _onPlayComplete() {
      console.log("audioplay event: LoadingCompleted");
      if (this.audioPlayer.audioStatus === 1) {
        this.unload();
        if (this.reconnectTimeout) {
          clearTimeout(this.reconnectTimeout);
        }
        this.reconnectTimeout = setTimeout(this._reconnect.bind(this), 3000);
      } else {
        setTimeout(this.destroy.bind(this), 0);
      }
    },
    _reconnect() {
      this.destroy();
      if (this.audioPlayer.audioStatus === 1) {
        console.log("Audio：正在重连...");
        this.audioPlayer.setPromptWord("reconnect");
        this.load();
      }
      this.reconnectTimeout = null;
    },
  },
  mounted() {
    this.audioPlayer.AudioPlay = this;
    flvjs.LoggingControl.enableDebug = false;
    flvjs.LoggingControl.enableVerbose = false;
    flvjs.LoggingControl.enableInfo = false;
  },
};
</script>

<style scoped>
/* 这里可以添加组件的样式 */
</style>
